<app-vis-dialog class="main-panel" [show]="show" (close)="close()">

<div style="display: flex;flex-direction: column;background: skyblue;position: relative;">
    <div style="width: 600px;display: flex;">
        <div style="flex-grow: 1;">{{msg}}</div>
        <app-vis-dropdownlist [(ngModel)]="gameMode" [data]="[{value:'PG',text:'抽鬼牌'},{value:'99',text:'99'}]"></app-vis-dropdownlist>
        <button (click)="start()">Start!!!</button>
    </div>
    <div class="msg-mask" *ngIf="gameOver">
        <div>{{gameOverMsg}}</div>
    </div>
    <div *ngIf="started" id="poke-desk" style="width: 600px;height: 600px;position: relative;">
        <div style="width: 500px;top: 0px; right: 0px;height: 100px;position: absolute;">
            <app-hand-cards  [seat]="1" [player]="playerSlot1"></app-hand-cards>
        </div>
        <div style="width: 100px;height: 500px;top: 0px;left: 0px; position: absolute;">
            <app-hand-cards  [seat]="4" [player]="playerSlot4"></app-hand-cards>
            
        </div>
        <div style="left: 100px;top: 100px; width: 400px;height: 400px;background: lawngreen;border: 1px solid #888;border-radius: 20px;padding: 20px;position: absolute;">
            <div style="width: 100%;display: flex;flex-wrap: wrap;">
                <div  *ngFor="let card of this.poke.desk" class="desk-card">
                    <app-poker-card [card]="card"></app-poker-card>
                </div>
            </div>
            <div *ngIf="poke.gameMode=='99'" style="bottom: 10px;position: absolute;left: 150px;width: 100px;height: 50px; text-align: center;font-size: 30px; border: 1px solid black;">
                {{poke.point}}    
            </div>
            <!--desk-->
        </div>
        <div style="right: 0px;bottom: 0px; width: 100px;height: 500px;position: absolute;">
            <app-hand-cards [seat]="2" [player]="playerSlot2"></app-hand-cards>
        </div>
        <div style="width: 500px;left: 0px;bottom: 0px; height: 100px;position: absolute;">
            <app-hand-cards [seat]="3" [player]="playerSlot3"></app-hand-cards>
        </div>
    </div>
</div>

</app-vis-dialog>